import { logD } from "@blacknut/logging/dist";
import { exitFullscreen } from "./exitFullscreen";
import { isFullscreen } from "./isFullscreen";
import { requestFullscreen } from "./requestFullscreen";
const LOGGING_TAG = "FullscreenHelper";
export declare type FullScreenCallback = (fullscreen: boolean) => void;

export interface FullscreenHelper {
  requestFullscreen: () => Promise<void>;
  exitFullscreen: () => Promise<void>;
  isFullscreen: () => Promise<boolean>;
  addFullcreenChangeListener: (listener: FullScreenCallback) => void;
  removeFullscreenChangeListener: (listener: FullScreenCallback) => void;
  teardown: () => void;
}

export class DefaultFullscreenHelper implements FullscreenHelper {
  private fullscreenListeners: FullScreenCallback[] = [];
  private fullscreenListener = () => {
    const fullscreen = isFullscreen(document);
    logD(LOGGING_TAG, "Fullscreen changed: %o", fullscreen);
    this.fullscreenListeners.forEach((listener) => {
      listener(fullscreen);
    });
  };
  constructor() {
    document.addEventListener("fullscreenchange", this.fullscreenListener);
    document.addEventListener("webkitfullscreenchange", this.fullscreenListener);
  }

  requestFullscreen() {
    return requestFullscreen(document);
  }
  exitFullscreen() {
    return exitFullscreen(document);
  }
  isFullscreen() {
    return Promise.resolve(isFullscreen(document));
  }

  addFullcreenChangeListener(callback: FullScreenCallback) {
    this.fullscreenListeners.push(callback);
  }
  removeFullscreenChangeListener(callback: FullScreenCallback) {
    this.fullscreenListeners = this.fullscreenListeners.filter((c) => c !== callback);
  }

  teardown() {
    logD(LOGGING_TAG, "Teardown");
    document.removeEventListener("fullscreenchange", this.fullscreenListener);
    document.removeEventListener("webkitfullscreenchange", this.fullscreenListener);
    this.fullscreenListeners = [];
  }
}
